import axios from 'axios';

const baseUrl = import.meta.env.VITE_APP_URL ? import.meta.env.VITE_APP_URL : 'http://localhost:8000';
const apiPath = `${baseUrl}/api`;

const getCookie = function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

const api = axios.create({
    baseURL: apiPath,
    headers: {
        // timeout: 1000, // indicates, 1000ms ie. 1 second
        "Content-Type" : "application/json",
        "Accept" : "application/json",
    }
})

api.defaults.withCredentials = true;

export default api;
